import { createSlice } from '@reduxjs/toolkit';
import { fetchBranchFeedback } from '../thunks/branchFeedbackThunks/thunks';

const initialState = {
  data: null,
  loading: false,
  error: null,
};

const branchFeedbackSlice = createSlice({
  name: 'branchFeedback',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchBranchFeedback.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBranchFeedback.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchBranchFeedback.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default branchFeedbackSlice.reducer;
